<template>
  <div class="is-slider">
    <carousel
      :perPage="1"
      :speed="150"
      :navigationEnabled="true"
      :paginationEnabled="false"
    >
      <slide v-for="i in slides" :key="i">
        <slot :name="i"></slot>
      </slide>
    </carousel>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel'
export default {
  components: {
    Carousel,
    Slide
  },
  props: ['slides']
}
</script>
